type Callback = () => void;
type SubscribeParams = {
    id: string;
    cb: Callback;
};

const georgeAppDidBecomeActiveCallbacks: Record<string, Callback> = {};
const georgeAppDidEnterBackgroundCallbacks: Record<string, Callback> = {};

export const subscribeToGeorgeAppDidBecomeActive = ({ id, cb }: SubscribeParams): void => {
    georgeAppDidBecomeActiveCallbacks[id] = cb;
};

export const unsubscribeFromGeorgeAppDidBecomeActive = (id: string): void => {
    delete georgeAppDidBecomeActiveCallbacks[id];
};

export const subscribeToGeorgeAppDidEnterBackground = ({ id, cb }: SubscribeParams): void => {
    georgeAppDidEnterBackgroundCallbacks[id] = cb;
};

export const unsubscribeFromGeorgeAppDidEnterBackground = (id: string): void => {
    delete georgeAppDidEnterBackgroundCallbacks[id];
};

const runAllGeorgeAppDidBecomeActiveCallbacks = (): void =>
    Object.values(georgeAppDidBecomeActiveCallbacks).forEach((cb) => {
        cb();
    });

const runAllGeorgeAppDidEnterBackgroundCallbacks = (): void =>
    Object.values(georgeAppDidEnterBackgroundCallbacks).forEach((cb) => {
        cb();
    });

export const initWebViewSuspend = (): void => {
    window.georgeAppDidBecomeActive = runAllGeorgeAppDidBecomeActiveCallbacks;
    window.georgeAppDidEnterBackground = runAllGeorgeAppDidEnterBackgroundCallbacks;
};
